import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import FileInput from "../../common/inputElements/FileInput";
import { getUserDetails } from "../../redux/actions/userActions";
import { patchAuthenticatedRequest } from "../../utils/API/api.ts";
import TextInputP from "../../common/inputElements/TextInputP.jsx";
import {
  USER_LOGIN_SUCCESS,
  USER_UPDATE_SUCCESS,
} from "../../redux/constants/userConstants.js";
import { useSelector } from "react-redux";
import CountryCode from "../../common/countryCodeWithNumber/CountryCode.jsx";
import countryCodes from "../../utils/CountryCodes.json";
import { showToast } from "../../redux/actions/toastActions.js";
import TextAreav2 from "../../common/inputElements/TextAreav2.jsx";
import MultiChipInputv2 from "../../common/inputElements/MultiChipInputv2.jsx";

const EditProfile = ({ savedUserConfig, setShowProfile }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [profilePicture, setProfilePicture] = useState("");
  const dispatch = useDispatch();
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const [countryCode, setCountryCode] = useState("+91");
  const [allCountryCode, setAllCountryCode] = useState(countryCodes);
  const [characterCount, setCharacterCount] = useState("");
  const [countryCodeLength, setCountryCodeLength] = useState({
    min: 10,
    max: 10,
  });
  const [inputValue, setInputValue] = useState("");
  const [chips, setChips] = useState([]);

  useEffect(() => {
    if (savedUserConfig?.email) {
      setValue("email", savedUserConfig?.email);
      setValue("mobile", savedUserConfig?.mobile);
      setValue("firstName", savedUserConfig?.firstName);
      setValue("lastName", savedUserConfig?.lastName);
      setValue("organization", savedUserConfig?.organization);
      setValue("jobTitle", savedUserConfig?.jobTitle);
      setValue("bio", savedUserConfig?.bio);
      if (savedUserConfig?.userTags?.length > 0) {
        setChips(savedUserConfig.userTags);
      } else {
        setChips(["Networking"]);
      }
      if (savedUserConfig?.countryCode) {
        setCountryCode(savedUserConfig?.countryCode);
      }
    }
  }, [savedUserConfig, setValue]);

  // useEffect(() => {
  //   if (countryCode) {
  //     const matchingCountries = countryCodes.filter(
  //       (country) =>
  //         country.dial_code
  //           .toLowerCase()
  //           .startsWith(countryCode.toLowerCase()) ||
  //         country.name.toLowerCase().startsWith(countryCode.toLowerCase()) ||
  //         country.code.toLowerCase().startsWith(countryCode.toLowerCase())
  //     );

  //     const nonMatchingCountries = countryCodes.filter(
  //       (country) =>
  //         !(
  //           country.dial_code
  //             .toLowerCase()
  //             .startsWith(countryCode.toLowerCase()) ||
  //           country.name.toLowerCase().startsWith(countryCode.toLowerCase()) ||
  //           country.code.toLowerCase().startsWith(countryCode.toLowerCase())
  //         )
  //     );

  //     setAllCountryCode([...matchingCountries, ...nonMatchingCountries]);
  //   }
  // }, [countryCode]);

  const onSubmit = async (data) => {
    setIsSubmitting(true);

    const matchingCountry = countryCodes.find(
      (country) => country.dial_code === countryCode
    );

    if (!matchingCountry) {
      dispatch(
        showToast({
          message: "Invalid Country Code.",
          category: "danger",
        })
      );
      setIsSubmitting(false);
      return;
    }

    const regex = new RegExp(
      `^[\\d]{${countryCodeLength?.min},${countryCodeLength?.max}}$`
    );

    if (!regex.test(data.mobile)) {
      dispatch(
        showToast({
          message: "Invalid Mobile Number or Country Code",
          category: "danger",
        })
      );
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await patchAuthenticatedRequest(
        `/user/${savedUserConfig._id}`,
        {
          ...data,
          email: savedUserConfig.email,
          profilePicture: profilePicture,
          countryCode: countryCode,
          userTags: chips,
        }
      );

      if (response?.status === 200) {
        dispatch(getUserDetails());
        dispatch({
          type: USER_LOGIN_SUCCESS,
          payload: {
            ...response?.data?.savedUserConfig,
            accessToken: userInfo.accessToken,
          },
        });
        setShowProfile(true);
        setIsSubmitting(false);
      }
    } catch (error) {
      console.log(error);
      alert("something went wrong!!");
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (savedUserConfig?.profilePicture) {
      setProfilePicture(savedUserConfig.profilePicture);
    }
  }, [savedUserConfig?.profilePicture]);

  return (
    <>
      {!savedUserConfig?.email ? (
        <></>
      ) : (
        <div
          className={`max-w-[1440px] w-full mx-auto min-h-[calc(100vh_-_60px)] md:w-[375px] mt-[40px]`}
        >
          <div className="w-full -mt-[10px]">
            <div className="w-full md:w-full p-5 pt-2">
              <div className="flex flex-col gap-y-5">
                <div>
                  <p className="font-[600] text-[23px]">Edit Profile</p>
                </div>
                <form onSubmit={handleSubmit(onSubmit)} className="">
                  <FileInput
                    profilePicture={profilePicture}
                    setProfilePicture={setProfilePicture}
                    label="Profile picture (Recommended size - 500 X 500 pixels)"
                    mb="5"
                    allowedFormats={["image/jpeg", "image/png"]}
                    maxSize={6} //in mb
                  />
                  <TextInputP
                    register={register}
                    type="text"
                    id={"firstName"}
                    label="First Name"
                    mb="[17px]"
                    required={true}
                    pattern={
                      /^(?=[A-Za-z\u0600-\u06FF])([A-Za-z\u0600-\u06FF\s'-]+)$/
                    }
                    errors={errors}
                  />
                  <TextInputP
                    register={register}
                    type="text"
                    id={"lastName"}
                    label="Last Name"
                    mb="[17px]"
                    required={true}
                    pattern={
                      /^(?=[A-Za-z\u0600-\u06FF])([A-Za-z\u0600-\u06FF\s'-]+)$/
                    }
                    errors={errors}
                  />
                  <TextInputP
                    register={register}
                    type="text"
                    id={"email"}
                    label="Email Address"
                    placeholder="Email Address"
                    disabled={true}
                    mb="[17px]"
                    required={true}
                    errors={errors}
                    pattern={
                      /^([a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)$/i
                    }
                  />

                  <div className="mb-[17px]">
                    <CountryCode
                      register={register}
                      countryCodeLength={countryCodeLength}
                      setCountryCodeLength={setCountryCodeLength}
                      allCountryCode={allCountryCode}
                      setAllCountryCode={setAllCountryCode}
                      countryCode={countryCode}
                      setCountryCode={setCountryCode}
                      errors={errors}
                    />
                  </div>
                  {/* <TextInputP
                register={register}
                type="tel"
                id={"mobile"}
                label="Phone Number"
                mb="[17px]"
                required={true}
              /> */}
                  <TextInputP
                    register={register}
                    type="text"
                    id={"organization"}
                    label="Company Name"
                    mb="[17px]"
                    required={true}
                    errors={errors}
                    pattern={
                      /^(?=[A-Za-z\u0600-\u06FF])([A-Za-z\u0600-\u06FF0-9\s.,&()-]+)$/
                    }
                  />
                  <TextInputP
                    register={register}
                    type="text"
                    id={"jobTitle"}
                    label="Designation"
                    mb="[17px]"
                    required={true}
                    pattern={
                      /^(?=[A-Za-z\u0600-\u06FF])([A-Za-z\u0600-\u06FF0-9\s.,&()-]+)$/
                    }
                    errors={errors}
                  />

                  <TextAreav2
                    register={register}
                    type="text"
                    mb="[17px]"
                    id={"bio"}
                    label={
                      characterCount
                        ? `Introduce yourself (${
                            characterCount.split("").length
                          }/600 characters)`
                        : "Introduce yourself"
                    }
                    placeholder="Passionate about building products that solve real problems. Leading product initiatives in AI-powered workflow automation"
                    maxLength={600}
                    onChange={(e) => setCharacterCount(e.target.value)}
                  />

                  <div className="w-full">
                    <MultiChipInputv2
                      setInputValue={setInputValue}
                      setChips={setChips}
                      inputValue={inputValue}
                      chips={chips}
                      limit={10}
                      required={false}
                      label="Tags that describe you"
                      style={{ marginBottom: "19px" }}
                      note="Press Enter to add multiple tags"
                      placeholder="Product Manager"
                    />
                  </div>

                  <div className="mt-[10px]">
                    <input
                      value={isSubmitting ? "Loading..." : "Save Changes"}
                      type="submit"
                      className="primary_submit"
                      disabled={isSubmitting}
                    />
                  </div>

                  <span
                    className="text-center flex items-center justify-center text-primary cursor-pointer text-[14px] font-medium gap-3 mt-3"
                    onClick={() => setShowProfile(true)}
                  >
                    <i className="fa-solid fa-arrow-left"></i> Go Back
                  </span>
                  <div className="spacer mb-[35px]"></div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EditProfile;
